function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1a1a1a;}.cls-2{fill:#f16224;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M107.359,23.7615a10.5764,10.5764,0,0,0-2.488.2961,10.5453,10.5453,0,1,0-16.1148,0,10.5462,10.5462,0,1,0,8.0574,10.2493A10.5454,10.5454,0,1,0,107.359,23.7615Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M117.8624,85.14c0-11.6246-21.0488-12.89-21.0488,3.191,0-16.0812-21.0486-14.8156-21.0486-3.191s14.12,23.0139,21.0486,32.77C103.5688,108.07,117.8624,96.7646,117.8624,85.14Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M96.8136,38.8925c0,5.4944-3.4389,8.8385-6.6581,10.7419H103.472C100.2526,47.731,96.8136,44.3869,96.8136,38.8925Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M26.0138,48.873H38.12a10.9287,10.9287,0,0,1-6.0531-9.7654A10.9285,10.9285,0,0,1,26.0138,48.873Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M32.0673,118.29c2.5645-5.2891,5.057-10.8838,9.2024-15.1617,4.3464-4.4854,10.2984-7.0137,15.7691-9.81-5.2611-2.614-10.8848-5.0607-15.173-9.1907-4.5017-4.3358-7.1892-10.2071-9.7987-15.7808C29.05,73.697,26.75,79.7683,22.2559,84.1152c-4.2739,4.1343-9.9,6.6045-15.16,9.2034,5.53,2.7036,11.4161,5.3209,15.7575,9.8232C26.9755,107.4174,29.5613,112.9837,32.0673,118.29Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M32.0671,34.1352c0,14.767,19.3285,13.6049,19.3285,2.93S38.43,16.5175,32.0671,7.5584c-6.2029,9.0353-19.3283,18.8322-19.3283,29.5069S32.0671,48.9022,32.0671,34.1352Z"
});

const SvgCasino2 = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 125 125",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCasino2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/casino2.b8ae7c15.svg";
export { ForwardRef as ReactComponent };